import { IconButton, InputAdornment, TextField } from "@mui/material";
import DatePicker from "react-datepicker";
import Clear from "@mui/icons-material/Clear";
import CalendarCheckFillIcon from "remixicon-react/CalendarEventFillIcon";
import dateformat from "dateformat";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";
import { DEFAULT_DATE_FORMAT } from "$utils/utils";

function DateInput({ startDate, endDate, label, onDateChange, ...props }: any) {
  const classes = useStyles();

  let inputDateValue = "";
  if (startDate) {
    inputDateValue = dateformat(startDate, DEFAULT_DATE_FORMAT);
  }
  if (startDate && endDate && startDate !== endDate) {
    const dStart = dateformat(startDate, DEFAULT_DATE_FORMAT);
    const dEnd = dateformat(endDate, DEFAULT_DATE_FORMAT);
    if (dStart === dEnd) {
      inputDateValue = dStart;
    } else {
      inputDateValue = `Du ${dStart} au ${dEnd}`;
    }
  }

  return (
    <TextField
      {...props}
      className={[classes.select, classes.DatePicker].join(" ")}
      value={inputDateValue}
      label={label}
      variant="outlined"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {startDate && (
              <IconButton
                onClick={() => {
                  onDateChange([null, null]);
                }}
                style={{ padding: 0 }}
              >
                <Clear />
              </IconButton>
            )}
            <CalendarCheckFillIcon
              color="#646262"
              style={{ marginLeft: "3px" }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
}

type Props = {
  endDate?: Date;
  label?: string;
  onChange: (dates: [Date, Date]) => void;
  startDate?: Date;
  placeholder?: string;
};

function DateRangePicker({
  startDate,
  endDate,
  label,
  onChange,
  placeholder,
}: Props) {
  return (
    <DatePicker
      placeholderText={placeholder}
      locale="fr"
      selected={startDate}
      onChange={onChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      customInput={
        <DateInput
          label={label}
          startDate={startDate}
          endDate={endDate}
          onDateChange={onChange}
        />
      }
    />
  );
}

const useStyles = createUseStyles(() => ({
  select: {
    flex: "1",
    paddingRight: "20px",
    "&:last-child": {
      padding: 0,
    },
    background: theme.color.white,
    "& .MuiInputLabel-shrink": {
      background: `${theme.color.white} !important`,
    },
  },
  DatePicker: {
    width: "100%",
    "& .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
      right: "10px !important",
    },
  },
}));

export default DateRangePicker;
